import React from 'react';
import {
  Stack,
  Input,
  Button,
  CircularProgress,
} from '@ltvco/refresh-lib/theme';
import { AutoAwesomeOutlined } from '@mui/icons-material';
import { theme } from 'theme';
import { ErrorMessageWithIcon } from 'components/shared/ErrorMessageWithIcon';

interface IVehicleSearchFormProps {
  searchValue: string;
  mileage: string;
  error: string | null;
  isLoading: boolean;
  onSearchValueChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onMileageChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSubmit: (e?: React.FormEvent<HTMLFormElement>) => Promise<void>;
}

/**
 * VehicleSearchForm - Form for entering vehicle search information
 * @component
 */
export const VehicleSearchForm = ({
  searchValue,
  mileage,
  error,
  isLoading,
  onSearchValueChange,
  onMileageChange,
  onSubmit,
}: IVehicleSearchFormProps) => {
  return (
    <Stack direction="row" width="100%">
      <AutoAwesomeOutlined sx={{ color: theme.palette.primary.main }} />
      <form onSubmit={onSubmit} style={{ width: '100%', marginLeft: '10px' }}>
        <Stack spacing={3} width={{ xs: '100%', md: '360px' }}>
          <Stack spacing={1}>
            <Input
              fullWidth
              value={searchValue}
              onChange={onSearchValueChange}
              placeholder="VIN, License Plate State, or Year Make Model"
              disabled={isLoading}
            />
            <Input
              fullWidth
              value={mileage}
              onChange={onMileageChange}
              placeholder="Current Mileage"
              disabled={isLoading}
            />
          </Stack>
          <ErrorMessageWithIcon errorMessage={error || ''} />
          <Button
            fullWidth
            type="submit"
            variant="contained"
            disabled={!searchValue || isLoading}
            startIcon={isLoading ? <CircularProgress size={20} /> : null}
          >
            Get Value Forecast
          </Button>
        </Stack>
      </form>
    </Stack>
  );
};
